import React from 'react';
import { components, ControlProps } from 'react-select';
import { OptionType } from '../../index.types';

/**
 * Custom control component for the Autocomplete.
 *
 * This component renders the control element and an optional label (if provided via props).
 * @returns A React element representing the control element
 */
export const AutocompleteControl = ({
  children,
  ...props
}: ControlProps<OptionType, false>): React.ReactElement => {
  const { label } = props.selectProps as { label?: string };

  return (
    <components.Control {...props}>
      {label && (
        <span className="pl-3 text-muted-foreground text-sm font-medium whitespace-nowrap flex-shrink-0 max-w-fit">
          {label}
        </span>
      )}
      {children}
    </components.Control>
  );
};